import { Injectable } from '@angular/core';
import { AuthSelectors, ClientSelectors } from '@store';
import { combineLatest } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LegacyService {

    constructor(
        private authSelector: AuthSelectors,
        private clientSelector: ClientSelectors
    ) {}

    navigate(url: string, windowName: string, params: string, sessionVars?: string) {
        combineLatest([this.authSelector.userCard$, this.clientSelector.client$]).pipe(
            tap(([userCard, client]) => {
                let allSessionVars = sessionVars;
                allSessionVars += `&mid=${userCard.cardId}&kontor=${userCard.kontor}`;
                allSessionVars += `&kid=${client.kid}&knr=${client.glkundenr}`;
                const encodedUrl = encodeURIComponent(url);
                const encodedParams = encodeURIComponent(params);
                if (navigator.userAgent.indexOf('Edg') !== -1) {
                    window.open(`${environment.legacyUrl}/api/redirect.asp?url=${encodedUrl}&windowName=${windowName}&windowParams=${encodedParams}${allSessionVars}`, '_blank').focus();
                } else {
                    location.href = `ie:${environment.legacyUrl}/api/redirect.asp?url=${encodedUrl}&windowName=${windowName}&windowParams=${encodedParams}${allSessionVars}`;
                }
            }),
            take(1)
        ).subscribe();
    }

    ia3Navigate(url: string, windowName: string, params: string, sessionVars?: string) {
        combineLatest([this.authSelector.userCard$, this.clientSelector.client$]).pipe(
            tap(([userCard, client]) => {
                let allSessionVars = sessionVars;
                allSessionVars += `&mid=${userCard.cardId}&kontor=${userCard.kontor}`;
                allSessionVars += `&kid=${client.kid}&knr=${client.glkundenr}`;
                const encodedUrl = encodeURIComponent(url);
                const encodedParams = encodeURIComponent(params);
                if (navigator.userAgent.indexOf('Edg') !== -1) {
                    window.open(`${environment.ia3LegacyUrl}/api/redirect.asp?url=${encodedUrl}&windowName=${windowName}&windowParams=${encodedParams}${allSessionVars}`, '_blank').focus();
                } else {
                    location.href = `ie:${environment.ia3LegacyUrl}/api/redirect.asp?url=${encodedUrl}&windowName=${windowName}&windowParams=${encodedParams}${allSessionVars}`;
                }
            }),
            take(1)
        ).subscribe();
    }
}
